import { Box } from "@vapor/react-material";

export const BorderedField = ({ children }) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                width: "fit-content",
                borderLeft: "5px solid #c9d9e8",
                pl: "25px",
                py: ".3rem",
                minWidth: "75%"
            }}
        >
            {children}
        </Box>
    );
};
